import { useMediaQuery } from 'react-responsive';

import * as cellSizing from './cellSizing';

export function usePurchaseTableLayout(): { packagesStacked: boolean } {
  const packagesStacked = useMediaQuery({
    query: cellSizing.packagesStackedQuery,
  });

  return { packagesStacked };
}
